import type { RecipientType as ApiRecipientType } from 'src/api/generated/touring/types';
import { mapRecipientPersonType } from '../../../mapGetAvailableRecipientsResponseType/helpers';
import type { RecipientType } from '../../types';

export const mapRecipientType = (api: ApiRecipientType): RecipientType => ({
  id: api.id,
  emailField: api.emailField,
  person: mapRecipientPersonType(api.person),
});
